var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Calculations, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calculate",
    d: "M8.82953 18H10.3295V16H12.3295V14.5H10.3295V12.5H8.82953V14.5H6.82953V16H8.82953V18ZM13.8295 17.25H18.8295V15.75H13.8295V17.25ZM13.8295 14.75H18.8295V13.25H13.8295V14.75ZM14.9295 10.95L16.3295 9.55L17.7295 10.95L18.7795 9.9L17.3795 8.45L18.7795 7.05L17.7295 6L16.3295 7.4L14.9295 6L13.8795 7.05L15.2795 8.45L13.8795 9.9L14.9295 10.95ZM7.07953 9.2H12.0795V7.7H7.07953V9.2ZM5.82953 21C5.27953 21 4.8087 20.8042 4.41703 20.4125C4.02536 20.0208 3.82953 19.55 3.82953 19V5C3.82953 4.45 4.02536 3.97917 4.41703 3.5875C4.8087 3.19583 5.27953 3 5.82953 3H19.8295C20.3795 3 20.8504 3.19583 21.242 3.5875C21.6337 3.97917 21.8295 4.45 21.8295 5V19C21.8295 19.55 21.6337 20.0208 21.242 20.4125C20.8504 20.8042 20.3795 21 19.8295 21H5.82953ZM5.82953 19H19.8295V5H5.82953V19Z",
    fill: "#707B8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculations);
export default __webpack_public_path__ + "static/media/Calculations.4f863f71e149cb9cae8673d9c0647ffb.svg";
export { ForwardRef as ReactComponent };